import { Typography, Button, Link, Dialog, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { WeavyLogoFilled } from '@/UI/Icons/WeavyLogoFilled';
import { I18N_KEYS } from '@/language/keys';
import { EXTERNAL_LINKS } from '@/consts/externalLinks.consts';

export function TermsOfServiceDialog({ onAccept }: { onAccept: () => void }) {
  const { t } = useTranslation();

  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: color.Black92,
          borderRadius: '13px',
          p: 4,
          pt: 5,
          position: 'relative',
        },
      }}
    >
      {/* Weavy logo */}
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          bgcolor: color.Black84,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <WeavyLogoFilled width={26} height={22} style={{ color: color.White100 }} />
      </Box>

      {/* Title */}
      <Typography variant="h2" sx={{ fontSize: '15px', fontWeight: 550, color: color.White100, mb: 1 }}>
        {t(I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_TITLE)}
      </Typography>

      {/* Body */}
      <Typography variant="body-std-rg" sx={{ color: color.White80_T, mb: 4, fontSize: '11px' }}>
        {t(I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_BODY)}{' '}
        <Link
          href={EXTERNAL_LINKS.termsOfService}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: color.Yellow100, textDecoration: 'none', fontSize: '11px' }}
        >
          {t(I18N_KEYS.SIGN_IN_PAGE.TERMS_OF_SERVICE_LINK)}
        </Link>{' '}
        and{' '}
        <Link
          href={EXTERNAL_LINKS.privacyPolicy}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: color.Yellow100, textDecoration: 'none', fontSize: '11px' }}
        >
          {t(I18N_KEYS.SIGN_IN_PAGE.PRIVACY_POLICY_LINK)}
        </Link>
        .
      </Typography>

      {/* Continue button */}
      <Button
        variant="contained"
        onClick={onAccept}
        fullWidth
        sx={{
          borderRadius: '4px',
          bgcolor: color.Yellow100,
          color: color.Black100,
          fontWeight: 500,
          fontSize: '14px',
          height: '32px',
          '&:hover': { bgcolor: color.Yellow64 },
        }}
      >
        {t(I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_ACCEPT_BUTTON)}
      </Button>
    </Dialog>
  );
}
